// libs
import React from 'react';

// style
import {
  MiddleSection,
  Heading,
  PartOne,
  PartTwo,
  RewardsBenefits,
  RewardsBenefitsContainer,
  RewardsBenefitsButton,
} from './styles';

// components
import TopSection from './components/TopSection';
import FaqAccordion from './components/FAQs';

// constants
import { TEXTS } from './constants';

const RewardsPage = () => {
  return (
    <div>
      <TopSection />
      <MiddleSection>
        <Heading>
          <PartOne>{TEXTS.ENJOY_BENEFITS}</PartOne>
          <PartTwo>{TEXTS.FLX_MEMBERSHIP}</PartTwo>
        </Heading>
        <RewardsBenefitsContainer>
          <RewardsBenefits src="https://asset.footlocker.co.in/footlocker-images/flx-ben.svg" />
          <RewardsBenefitsButton onClick={() => window.open('https://www.footlocker.co.in')} />
        </RewardsBenefitsContainer>
      </MiddleSection>
      <FaqAccordion />
    </div>
  );
};

export default RewardsPage;
